import { useForm } from "react-hook-form";
import { JVDate } from "../../../shared/JVDate";
import { JVDropdown } from "../../../shared/JVDropdown";
import { DataTable } from "primereact/datatable";
import React, { useEffect, useRef, useState } from "react";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { ILogin, IPermissionProps } from "../../../models/Login";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { Accordion, AccordionTab } from "primereact/accordion";
import { Toolbar } from "primereact/toolbar";
import { IModal } from "./ShowTimesheet";
import { format } from "date-fns";
import { Fetch, baseUrl } from "../../../shared/Fetch";
import { ITimesheet, VerifyStatus } from "../../../models/Timesheet";
import { VerifyForm } from "./VerifyForm";
import { Mail } from "./Mail";
import { JVInput } from "../../../shared/JVInput";
import { IPurchaseOrder, POStatus } from "../../../models/PurchaseOrder";
import { AutoFillTimeSheet } from "./AutoFillTimeSheet";
import { useNavigate } from "react-router-dom";
import { PO_Status, POStatusMap } from "../../../models/FDropdown";
// import { ConnectedOverlayScrollHandler } from "primereact/utils";

interface ITimesheetFilter {
    fromDate?: Date | null,
    toDate?: Date | null,
    status?: string | null,
    consultant_Name?: string | null,
    pO_Status?: POStatus | null,
}

interface IProps {
    setModal: (modal: IModal) => void,
    toast: any,
    reload: boolean,
    setReload: (is: boolean) => void,
    permissions: IPermissionProps,
    byConsultant: number,
    po: IPurchaseOrder,
    subVendor: boolean
}

const schema = yup.object({
    date: yup.date().nullable(),
    status: yup.string().nullable(),
    pO_Status: yup.string().nullable(),
});

const EmptyTSFilter: ITimesheetFilter = {
    fromDate: null,
    toDate: null,
    status: "",
    consultant_Name: "",
    pO_Status: null,
}

export const Table = (props: IProps) => {
    const [tableData, setTableData] = useState({ tableData: [], loading: false } as { tableData: Array<ITimesheet>, loading: boolean });
    const [autoFillTimesheet, setAutoFillTimesheet] = useState({ singleData: {}, open: false, po: {}, recent: {}, timeSheetCount: 0 } as { singleData: any, open: boolean, po: any, recent: any, timeSheetCount: number });
    const [filters, setFilters] = useState<ITimesheetFilter>(EmptyTSFilter);
    const [timesheetLeft, setTimesheetLeft] = useState<number>(0);
    const [po, setPo] = useState<IPurchaseOrder>({});
    const [leftTimesheetDates, setLeftTimesheetDates] = useState<string[]>([]);
    const [consultant, setConsultant] = useState<Array<any>>();
    const [verify, setVerify] = useState({ singleData: {}, open: false } as { singleData: ITimesheet, open: boolean });
    const [mail, setMail] = useState({ singleData: {}, open: false } as { singleData: ITimesheet, open: boolean });
    const navigate = useNavigate();

    const dt = useRef<any>(null);
    const previousValue = useRef<boolean>(false);

    const { control, handleSubmit, reset } = useForm<ITimesheetFilter>({
        resolver: yupResolver(schema),
        defaultValues: EmptyTSFilter,
        shouldFocusError: false
    });

    const exportCSV = () => {
        dt.current.exportCSV();
    };

    const loginObj: ILogin = JSON.parse(sessionStorage.getItem('auth') + '');

    const loadTableData = async (filter: ITimesheetFilter) => {
        setTableData({ tableData: tableData.tableData, loading: true });

        let userType = "";

        // if (loginObj.user_Type === 2) {
        //     userType = `&byConsultant=${loginObj.consultant_ID}&userType=${loginObj.user_Type}`;
        // }

        // if (loginObj.user_Type === 3) {
        //     userType = `&bySubvendor=${loginObj.sub_Vendor_ID}&userType=${loginObj.user_Type}`;
        // }

        let po_id_Query = "";
        if (props?.po?.pO_ID || (po?.pO_ID && po?.pO_ID !== 0)) {
            po_id_Query = `&byPO_ID=${props?.po?.pO_ID || po?.pO_ID}`;
            filters.fromDate = null;
            filters.toDate = null;
        };

        const response = await Fetch("ResourceTimesheet/getTimesheets", "GET", null, `filter=${JSON.stringify(filter || filters)}` + po_id_Query, props.toast);
        if (response) {
            const data: Array<ITimesheet> = await response.json();
            setTableData({ tableData: data, loading: false });
            props.setReload(false);
        }
    }
    // const loadInnerTableData = async (filters: ITimesheetFilter, consultant_ID: number, pO_ID: number) => {
    //     setTableData({ tableData: tableData.tableData, loading: true });
    //     const response = await Fetch("ResourceTimesheet/consultant", "GET", null, `consultant_ID=${consultant_ID}&filter=${JSON.stringify(filters)}&po_ID=${pO_ID}`, props.toast);
    //     if (response) {
    //         const data: Array<ITimesheet> = await response.json();
    //         setTableData({ tableData: data, loading: false });
    //     }
    // }
    const [consultantTable, setConsultantTable] = useState({ singleData: {}, open: false } as { singleData: ITimesheet, open: boolean });

    // useEffect(() => {
    //     if (previousValue.current === consultantTable.open) {
    //         if (consultantTable.open && consultantTable.singleData.consultant_ID) {
    //             if (po?.pO_ID) loadInnerTableData(filters, 0, po?.pO_ID)
    //             else loadInnerTableData(filters, consultantTable.singleData.consultant_ID, 0);
    //         }
    //         else loadTableData(filters);
    //     } else {
    //         previousValue.current = consultantTable.open;
    //         if (consultantTable.open && consultantTable.singleData.consultant_ID) {
    //             if (po?.pO_ID) loadInnerTableData({}, 0, po?.pO_ID)
    //             else loadInnerTableData({}, consultantTable.singleData.consultant_ID, 0);
    //             reset({});
    //         }
    //         else { loadTableData(EmptyTSFilter); reset(EmptyTSFilter); }
    //     }
    // }, [filters, props.reload, consultantTable.open]);

    const openNew = (rowData: ITimesheet) => {
        props.setModal({ open: true, singleData: { consultant_ID: rowData.consultant_ID, pO_ID: rowData?.pO_ID }, po: po, recent: tableData.tableData[0] });
    };
    const openEdit = (rowData: ITimesheet) => {
        props.setModal({ open: true, singleData: rowData, po: {}, recent: {} });
    };

    const hideVerifyDialog = () => { setVerify({ singleData: {}, open: false }); loadTableData(filters); };
    const hideMailDialog = () => { setMail({ singleData: {}, open: false }) };
    const hideAutoFilltTimesheetDialog = () => { setAutoFillTimesheet({ singleData: {}, open: false, po: {}, recent: {}, timeSheetCount: 0 }); };

    const downloadTimeSheet = async (data: ITimesheet) => {
        const params = {
            method: "POST",
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${JSON.parse(sessionStorage.getItem('auth') + "")?.token}`
            },
            body: JSON.stringify(data)
        };
        try {
            const response = await fetch(`${baseUrl}${"ResourceTimesheet/download"}`, params);
            if (response.status === 200) {
                const blob = await response.blob();
                const href = window.URL.createObjectURL(blob);
                const a = document.createElement("a");
                a.download = data.timeSheet_Path ? data.timeSheet_Path : "timeSheet";
                a.href = href;
                a.click();
                a.href = '';
            } else if (response.status === 400) {
                const message = await response.text();
                props.toast.current.show({ severity: 'error', detail: message, life: 3000 });
            }
        } catch {
            props.toast.current.show({ severity: 'error', detail: 'Something went Wrong', life: 3000 });
        }
    }

    const leftToolbarTemplate = () => {
        return (
            <>
                {props?.po?.pO_ID ? <>
                    <Button label="New" icon="pi pi-plus" className="p-button-success mr-2 w-6rem mt-2" onClick={() => {
                        // console.log(props?.po, po);
                        if ((new Date() <= new Date(props?.po?.project_End_Date || po.project_End_Date || "")) && (props?.po?.pO_Status === POStatus.Joined || po.pO_Status === POStatus.Joined) && (props?.po?.prime_Vendor_Billing_Cycle || po.prime_Vendor_Billing_Cycle)) {
                            props.setModal({ open: true, singleData: { consultant_ID: props?.po?.consultant_ID || po?.consultant_ID, pO_ID: props?.po?.pO_ID || po?.pO_ID }, po: props?.po || po, recent: tableData.tableData[0] })
                        } else if (props?.po?.project_End_Date !== undefined && props?.po?.project_End_Date !== null && new Date(tableData.tableData[0]?.toDate || "") < new Date(props?.po?.project_End_Date || "")) {
                            props.setModal({ open: true, singleData: { consultant_ID: props?.po?.consultant_ID || po?.consultant_ID, pO_ID: props?.po?.pO_ID || po?.pO_ID }, po: props?.po || po, recent: tableData.tableData[0] });
                        } else if ((new Date() > new Date(props?.po?.project_End_Date || po.project_End_Date || ""))) {
                            props.toast.current.show({ severity: 'error', detail: "Project Ended", life: 3000 });
                        } else if (!(props?.po?.prime_Vendor_Billing_Cycle || po.prime_Vendor_Billing_Cycle)) {
                            props.toast.current.show({ severity: 'error', detail: `Billing Cycle is not Updated`, life: 3000 });
                        } else if ((props?.po?.pO_Status || po.pO_Status) !== POStatus.Joined) {
                            props.toast.current.show({ severity: 'error', detail: `Consultant PO Status ${POStatus[props?.po?.pO_Status || po.pO_Status || 1]}`, life: 3000 });
                        };
                    }} />
                    {/* {props?.po?.consultant_Name && <h5 className="ml-5">{props?.po?.consultant_Name}</h5>} */}
                </> : <></>}
            </>
        );
        // if (po?.pO_ID) {
        //     return (
        //         <React.Fragment>
        //             <Button label="New" icon="pi pi-plus" className="p-button-success mr-2 w-6rem" onClick={() => {
        //                 if ((new Date() <= new Date(po.project_End_Date || "")) && po.pO_Status === POStatus.Joined && po.prime_Vendor_Billing_Cycle) {
        //                     props.setModal({ open: true, singleData: { consultant_ID: po?.consultant_ID, pO_ID: po?.pO_ID }, po: po, recent: tableData.tableData[0] })
        //                 } else if ((new Date() > new Date(po.project_End_Date || ""))) {
        //                     props.toast.current.show({ severity: 'error', detail: "Project Ended", life: 3000 });
        //                 } else if (po.pO_Status !== POStatus.Joined) {
        //                     props.toast.current.show({ severity: 'error', detail: `Consultant PO Status ${po.pO_Status}`, life: 3000 });
        //                 };
        //             }} />
        //         </React.Fragment>
        //     );
        // } else {
        //     return (
        //         <React.Fragment>
        //             {consultantTable.open && <Button label="Go Back" icon="pi pi-arrow-left" className="p-button-info" onClick={() => setConsultantTable({ singleData: {}, open: false })} />}
        //         </React.Fragment>
        //     );
        // }
    };
    const rightToolbarTemplate = () => {
        return (
            <React.Fragment>
                <div className="flex w-full">
                    <div className="flex w-25rem">{timesheetLeft !== 0 && <h1 className="flex text-4xl font-bold mr-5 hover:text-blue-700 hover:underline" style={{ cursor: "pointer" }} onClick={() => {
                        //if (props?.po?.pO_ID) setAutoFillTimesheet({ open: true, singleData: { consultant_ID: props?.po?.consultant_ID, pO_ID: props?.po?.pO_ID }, po: props?.po, recent: {}, timeSheetCount: timesheetLeft });
                    }}>Pending Timesheets : <span style={{ color: 'red' }}>{timesheetLeft}</span></h1>}</div>
                </div>
                {/* <Button label="Export" icon="pi pi-upload" className="p-button-help" onClick={exportCSV} /> */}
            </React.Fragment>
            //  : (<div className="flex align-items-center justify-content-center">
            //     <div>{timesheetLeft !== 0 && <h1 className="text-4xl font-bold mr-5" style={{ cursor: "pointer" }} onClick={() => {
            //         // setAutoFillTimesheet({ open: true, singleData: { consultant_ID: po.consultant_ID, pO_ID: po.pO_ID }, po: po, recent: tableData.tableData[0], timeSheetCount: timesheetLeft });
            //     }}>Pending Timesheets : <span style={{ color: 'red' }}>{timesheetLeft}</span></h1>}</div>
            // </div>)
        );
    };

    const onSubmit = (data: ITimesheetFilter) => {
        if (data.status === "--SELECT--") data.status = "";
        //console.log("data", data);
        data.consultant_Name = data.consultant_Name != null ? data.consultant_Name.split("(")[0].trim() : null;
        loadTableData(data);
        setFilters(prev => prev = data);
    }

    const newTS = (rowData: ITimesheet) => {
        return (<Button icon="pi pi-plus" className="p-button-success p-button-rounded p-button-text" onClick={() => openNew(rowData)} />);
    };
    const getConsultantName = async () => {
        const response = await Fetch("DropDown/consultantNameList", "GET", null, `isTimesheet=1`, null);
        if (response) {
            const data: any = await response.json();
            setConsultant(data);
        }
    }
    const start_Date = (rowData: ITimesheet) => {
        let date;
        if (rowData.start_Date) date = format(new Date(rowData.start_Date), 'MM/dd/yyyy').toUpperCase();
        else date = "";
        return (<>{date}</>);
    };
    const fromDate = (rowData: ITimesheet) => {
        let date;
        if (rowData.fromDate) date = format(new Date(rowData.fromDate), 'MM/dd/yyyy').toUpperCase();
        else date = "";
        return (<>{date}</>);
    };
    const toDate = (rowData: ITimesheet) => {
        let date;
        if (rowData.toDate) date = format(new Date(rowData.toDate), 'MM/dd/yyyy').toUpperCase();
        else date = "";
        return (<>{date}</>);
    };
    const actionBodyTemplate = (rowData: ITimesheet) => {
        if (rowData.verify_Status === VerifyStatus.Not_Worked || (rowData.verifiedBy !== null && rowData.verify_Status === VerifyStatus.Verified)) {
            return "";
        }
        return (
            (props.permissions.is_Update && (props.po.pO_Status === POStatus.Joined || rowData.pO_Status === POStatus.Joined)) ?
                <>
                    <Button icon="pi pi-pencil" label="Edit" className="p-button-rounded p-button-text w-5rem" onClick={() => {
                        if (rowData.timesheet_ID) openEdit({
                            timesheet_ID: rowData.timesheet_ID,
                            consultant_ID: rowData.consultant_ID,
                            fromDate: new Date(rowData.fromDate || ""),
                            toDate: new Date(rowData.toDate || ""),
                            workHours: rowData.workHours,
                            comments: rowData.comments,
                            timeSheet_Path: rowData.timeSheet_Path,
                            isNotWorking: rowData.isNotWorking,
                            overlapWorkHours: rowData.overlapWorkHours,
                        })
                    }} />
                </>
                : ''
        );
    };
    const d_timesheet = (rowData: ITimesheet) => {
        return (<span onClick={() => {
            if (rowData.consultant_ID && rowData.timeSheet_Path && rowData.isNotWorking !== true) downloadTimeSheet({ pO_ID: rowData?.pO_ID, timeSheet_Path: rowData.timeSheet_Path })
            else props.toast.current.show({ severity: 'error', detail: "TimeSheet Not Found.", life: 3000 });
        }} className="cursor-pointer text-cyan-700 underline">Download</span>);
    };
    const send_Email = (rowData: ITimesheet) => {
        return (<span onClick={() => setMail({ singleData: rowData, open: true })} className="cursor-pointer text-cyan-700 underline">Send Email</span>);
    };

    const rowClass = (data: ITimesheet) => {
        return {
            'bg-green-300 text-black': data.verify_Status === VerifyStatus.Verified || data.verify_Status === VerifyStatus.Not_Worked,
            'bg-yellow-100 text-black': data.verify_Status === null || data.verify_Status === VerifyStatus.Pending,
            'bg-pink-100 text-black': data.verify_Status === VerifyStatus.UnVerified,
        };
    };

    const status = (rowData: ITimesheet) => {
        return <span style={{ color: (rowData.verify_Status === VerifyStatus.UnVerified) ? "red" : "black" }}>{rowData.verify_Status ? VerifyStatus[rowData.verify_Status] : ''}</span>;
    };

    const GetTimesheetLeft = async () => {
        let extraQuery = "";

        const response = await Fetch("vwPODetailsExternalUser/getTimesheetOrInvoiceLeft", "GET", null, `PO_ID=${props?.po?.pO_ID || po?.pO_ID}&dataType=1` + extraQuery, props.toast);
        if (response) {
            const data = await response.json();
            setTimesheetLeft(data.timesheetLeft);
        }
    };
    const getTimesheetLeft2 = async () => {
        let extraQuery = "";

        const response = await Fetch("vwPODetailsExternalUser/getTimesheetInvoiceLeft", "GET", null, `filter=${JSON.stringify(filters)}&dataType=1` + extraQuery, props.toast);
        if (response) {
            const data = await response.json();
            setTimesheetLeft(prev => prev = data.timesheetLeft);
        }
    };

    const goToDashboard = () => {
        navigate("/dashboard");
    };


    // const GetTimesheetLeftDates = async () => {
    //     let extraQuery = "";
    //     // if (loginObj.user_Type === 2) {
    //     //     extraQuery = `&consultantUser=${loginObj.consultant_ID}&userType=${loginObj.user_Type}`;
    //     // }

    //     // if (loginObj.user_Type === 3) {
    //     //     extraQuery = `&subvendorUser=${loginObj.sub_Vendor_ID}&userType=${loginObj.user_Type}`;
    //     // }
    //     const response = await Fetch("ResourceTimesheet/getLeftTimeSheetDates", "GET", null, `PO_ID=${props?.po?.pO_ID || po?.pO_ID}&dataType=1` + extraQuery, props.toast);
    //     if (response) {
    //         const data = await response.json();
    //         setLeftTimesheetDates(data);
    //     }
    // };

    // const getConsultantPODetails = async () => {
    //     let externalUserFilter = "";
    //     if (loginObj.user_Type === 2) {
    //         externalUserFilter = `&consultantUser=${loginObj.consultant_ID}&userType=${loginObj.user_Type}`;
    //     }
    //     if (loginObj.user_Type === 3) {
    //         externalUserFilter = `&subvendorUser=${loginObj.sub_Vendor_ID}&userType=${loginObj.user_Type}`;
    //     };

    //     const response = await Fetch("vwPODetailsExternalUser", "GET", null, `filter=${JSON.stringify({})}` + externalUserFilter, props.toast);
    //     if (response) {
    //         const data: Array<IPurchaseOrder> = await response.json();
    //         setPo(data[0]);
    //     }
    // }

    // useEffect(() => {
    //     if (!props?.po?.pO_ID) {
    //         getConsultantPODetails();
    //     }
    //     // if (po?.pO_ID) {
    //     // GetTimesheetLeft();
    //     // }
    // }, [props.toast]);

    // useEffect(() => {
    //     if (props?.po?.pO_ID || po?.pO_ID) {
    //         loadTableData({});
    //         GetTimesheetLeft();
    //         GetTimesheetLeftDates();
    //     }
    // }, [po, props.po]);

    useEffect(() => {
        if (props.reload) {
            loadTableData(filters);
        }
    }, [props.reload]);

    useEffect(() => {
        loadTableData(filters);
    }, [filters]);

    useEffect(() => {
        getConsultantName();
    }, []);

    useEffect(() => {
        if (props?.po?.pO_ID) GetTimesheetLeft();
        else getTimesheetLeft2();
    }, [props?.po]);

    return (
        <>
            {!props?.po?.pO_ID && <p className="w-full flex justify-content-between pr-2"><span style={{ fontWeight: "bold" }}>Pending Timesheets</span><span></span><Button className="w-12rem" label="Go to Dashboard" onClick={goToDashboard} icon="pi pi-arrow-left" /></p>}
            {props.subVendor && !props?.po?.pO_ID && <Accordion>
                <AccordionTab header="Filter">
                    <form onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid">
                        <JVDate column={6} label="From Date" control={control} name="fromDate" />
                        <JVDate column={6} label="To Date" control={control} name="toDate" />
                        {/* <JVDropdown column={6} label="Timesheet Status:" control={control} name="status" options={[
                            { name: "--SELECT--" },
                            { name: VerifyStatus.Pending },
                            { name: "Complete" },
                        ]} optionLabel="name" optionValue="name" placeholder="Select Status" /> */}
                        <JVDropdown column={6} label="PO Status:" control={control} name="pO_Status" options={
                            PO_Status
                        } optionLabel="name" optionValue="id" placeholder="Select PO Status" />
                        {/* <JVInput column={6} label="Consultant Name" control={control} name="consultant_Name" /> */}
                        <JVDropdown column={6} label="Consultant Name " filter control={control} name="consultant_Name" options={consultant} optionLabel="consultant_Name" optionValue="consultant_Name" placeholder="Select Consultant " />
                        <div className="col-12 md:col-12" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', columnGap: '10px', marginTop: '10px' }}>
                            <Button className="field col-12 md:col-6  h-2rem" label="SEARCH" type="submit"></Button>
                            <Button className="field col-12 md:col-6 p-button-outlined  h-2rem" label="CLEAR" onClick={() => { reset() }} type="button"></Button>
                        </div>
                    </form>
                </AccordionTab>
            </Accordion>}

            <Toolbar className="mb-1 py-0" left={leftToolbarTemplate} right={rightToolbarTemplate}></Toolbar>
            <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0", marginTop: "10px" }}
                ref={dt} size="small" stripedRows showGridlines exportFilename={format(new Date(), 'dd-MM-yyyy hh_mm_ss a').toUpperCase()}
                value={tableData.tableData}
                loading={tableData.loading}
                rowClassName={rowClass}
            >
                {/* {!po?.pO_ID && <Column body={newTS} />} */}
                <Column field="consultant_Name" header="Name" />
                {/* <Column field="client" header="Client" /> */}
                <Column field="end_Client" header="End Client" />
                <Column field="pO_Status" header="PO Status" body={r => r.pO_Status ? POStatusMap[r.pO_Status] : ''} />
                <Column field="fromDate" header="From Date" body={fromDate} />
                <Column field="toDate" header="To Date" body={toDate} />
                <Column field="start_Date" header="Start Date" body={start_Date} />
                {/* <Column field="workHours" header="Hours" /> */}
                <Column field="workHours" header="Hours" body={(rowData: any) => <p>{(rowData.workHours || 0) + (rowData.overlapWorkHours || 0)}</p>} />
                <Column header="Download" body={d_timesheet} />
                <Column field="addedBy" header="Added By" />
                <Column field="editedBy" header="Edited By" />
                <Column field="verifiedBy" header="Verified By" />
                <Column field="timeSheet_Status1" header="Status" body={status} />
                {/* <Column header="Email Inv" body={send_Email} /> */}
                <Column header="Action" body={actionBodyTemplate} />
            </DataTable>
            <VerifyForm singleData={verify.singleData} open={verify.open} toast={props.toast} hideDialog={hideVerifyDialog} reload={props.reload} setReload={props.setReload} />
            <Mail singleData={mail.singleData} open={mail.open} toast={props.toast} hideDialog={hideMailDialog} />
            <AutoFillTimeSheet singleData={autoFillTimesheet.singleData} open={autoFillTimesheet.open} hideDialog={hideAutoFilltTimesheetDialog} toast={props.toast} setReload={props.setReload} po={autoFillTimesheet.po} recent={autoFillTimesheet.recent} timeSheetCount={autoFillTimesheet.timeSheetCount} reloadDialog={() => {
                loadTableData(filters);
                GetTimesheetLeft();
            }} />
        </>
    );
}